import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { formatNaira } from "../../productsData";

export default function ProductCard({ product }) {
  const { addItem } = useCart();

  const handleAddToCart = (e) => {
    // Stop the click from also following the <Link> to the product page.
    e.preventDefault();
    e.stopPropagation();
    addItem(product, product.sizes[0]);
  };

  return (
    <div className="merch-card">
      <Link to={`/shop/${product.slug}`}>
        <div className="merch-thumb">
          {product.isNew && <span className="merch-badge-new">New</span>}
          <img src={product.images[0]} alt={product.name} />
        </div>
      </Link>
      <div className="merch-body">
        <Link to={`/shop/${product.slug}`} className="merch-name-link">
          <div className="merch-name">{product.name}</div>
        </Link>
        <div className="merch-size">{product.sizes.join(" · ")}</div>
        <div className="merch-price">{formatNaira(product.price)}</div>
        <button className="btn-mu-dark" onClick={handleAddToCart}>Add to Cart</button>
      </div>
    </div>
  );
}
